<template>
  <template v-if="props.product?.type === 'contingent'">
    <span class="status status-yellow" v-if="(props.product?.refill_interval || 0) <= 0">Non-Refill</span>
    <span class="status status-blue" v-else>Auto-Refill</span>
  </template>
</template>
<script setup lang="ts">
interface IProps {
  product: { type: string; refill_interval?: number | null };
}

const props = withDefaults(defineProps<IProps>(), { product: undefined });
</script>
<style scoped>
.status {
  font-size: 0.8rem !important;
  font-weight: 500;
}
</style>
